import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    index: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    show: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    create: async (intendedType, handleRedirect = null, name = "Draft Mission") => {
        const url = apiConfig.apiUrl + "missions/";

        const body = JSON.stringify({
            mission: {
                name,
                intended_mission_type: intendedType,
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    updateSessionDetails: async (missionId, sessionLength, numberRespondents, videoRequired, attendees, timezone, deviceRequirement, requireShareScreen, requireWalletUsage, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/update_mission_and_create_mission_event";

        // const format = `${sessionLength}-minute ${videoRequired ? "video" : "audio-only"} interview`

        const body = JSON.stringify({
            mission: {
                num_total_spots: numberRespondents,
                device_requirement: deviceRequirement,
                require_share_screen: requireShareScreen,
                require_wallet_usage: requireWalletUsage,
            },
            mission_event: {
                session_length_in_minutes: sessionLength,
                video_required: videoRequired,
                timezone: timezone,
            },
            mission_attendees: attendees
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    updateSurveyDetails: async (missionId, numberRespondents, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId;

        const body = JSON.stringify({
            mission: {
                num_total_spots: numberRespondents,
            },

        });

        try {
            const response = await fetch(url, {
                method: "PUT",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    // Update function

    update: async ({ missionId, name, description, status, numResponses, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId;

        const body = JSON.stringify({
            mission: {
                name: name,
                audience_description: description,
                num_total_spots: numResponses,
                status: status,
            },
        });

        try {
            const response = await fetch(url, {
                method: "PATCH",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    updateAttendees: async ({ missionId, attendees, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/update_mission_attendees";

        const body = JSON.stringify({
            mission_attendees: attendees
        });

        try {
            const response = await fetch(url, {
                method: "PATCH",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    updateRequiresReview: async (missionId, requiresReview, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId;

        const body = JSON.stringify({
            mission: {
                requires_researcher_review: requiresReview,
                requires_review: requiresReview,
            },
        });

        try {
            const response = await fetch(url, {
                method: "PATCH",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    updateViewUserWallets: async (missionId, viewUserWallets, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId;

        const body = JSON.stringify({
            mission: {
                view_user_wallets: viewUserWallets,
            },
        });

        try {
            const response = await fetch(url, {
                method: "PATCH",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    showIntendedMissionType: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/intended_mission_type";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    showSurveyResponses: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/show_survey_responses";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    duplicate: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/duplicate";

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    delete: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId;

        try {
            const response = await fetch(url, {
                method: "DELETE",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    close: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/close_mission";

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: JSON.stringify({}),
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }

}